import { render } from "./yaffoCroisades.vue?vue&type=template&id=8db52118&scoped=true"
import script from "./yaffoCroisades.vue?vue&type=script&lang=js"
export * from "./yaffoCroisades.vue?vue&type=script&lang=js"

import "./yaffoCroisades.vue?vue&type=style&index=0&id=8db52118&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8db52118"]])

export default __exports__